import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getBarberShortName } from '../barbers/selectors';

const mapStateToProps = (state, ownProps) => ({
  barberName: getBarberShortName(state, ownProps.params.barberRoute),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithBarberShortName.js